import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toman',

})
export class TomanPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) { }

  transform(rial?: number, ...args: unknown[]): string {
    var toman = !args.includes('rial');
    var value = rial ? toman ? rial / 10 : rial : 0;
    var currency = toman ? 'تومان' : 'ریال';
    var unit = '';

    if (value > 1000000000) {
      value = value / 1000000000;
      unit = ' میلیارد';
    } else if (value > 1000000) {
      value = value / 1000000;
      unit = ' میلیون';
    } else if (value > 1000) {
      value = value / 1000;
      unit = ' هزار';
    }

    return `${this.decimalPipe.transform(value)}${unit} ${currency}`;
  }

}
